const counselRouters = [
  {
    path: "/counsel",
    meta: {
      title: "상담신청",
      titleEn: "counsel",
    },
    children: [
      {
        path: "student",
        component: () =>
          import("@/views/student/counsel/StudentCounselIndex.vue"),
        meta: {
          title: "상담신청",
          menuCd: "COUNSEL_STUDENT",
        },
        children: [
          {
            path: "",
            name: "CounselApply",
            component: () =>
              import("@/views/student/counsel/detail/CounselApply.vue"),
          },
          {
            path: "my-history",
            name: "MyCounselHistory",
            component: () =>
              import("@/views/student/counsel/detail/MyCounselHistory.vue"),
          },
        ],
      },
    ],
  },
];

export default counselRouters;
